import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { GridsterModule } from 'angular-gridster2';
import { ChartModule } from 'angular-highcharts';
import { I18NextModule } from 'angular-i18next';
// import { AngularResizeEventModule } from 'angular-resize-event';
import { AngularResizeEventModule } from 'angular-resize-event-package';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { ColorSketchModule } from 'ngx-color/sketch';
import { dashboardReducer } from 'src/app/dashboards/state/dashboards.reducer';
import { ReportsDatePickerComponent } from 'src/app/reports/reports-date-picker/reports-date-picker.component';
import { DialogCategoriesComponent } from '../common/dialogs/dialog-categories/dialog-categories.component';
import { SharedModule } from '../shared/shared.module';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { DashboardAccessIconComponent } from './components/dashboard-access-icon/dashboard-access-icon.component';
import { DashboardFilterComponent } from './components/dashboard-filter/dashboard-filter.component';
import { DialogDashboardNew } from './components/dialog-dashboard-new/dialog-dashboard-new';
import { DialogDatetimepickerComponent } from './components/dialog-datetimepicker/dialog-datetimepicker.component';
import { ManualRowSortComponent } from './components/manual-row-sort/manual-row-sort.component';
import { PreferencesComponent } from './components/preferences/preferences.component';
import { RelativeDateSelectComponent } from './components/relative-date-select/relative-date-select.component';
import { SortComponent } from './components/sort-component/sort.component';
import { WidgetAgentSelectComponent } from './components/widget-agent-select/widget-agent-select.component';
import { WidgetNumberboxComponent } from './components/widget-numberbox/widget-numberbox.component';
import { WidgetReportColumnsSelectComponent } from './components/widget-report-columns-select/widget-report-columns-select.component';
import { WidgetReportSelectComponent } from './components/widget-report-select/widget-report-select.component';
import { WidgetSelectComponent } from './components/widget-select/widget-select.component';
import { WidgetTextboxComponent } from './components/widget-textbox/widget-textbox.component';
import { WidgetTypeSelectComponent } from './components/widget-type-select/widget-type-select.component';
import { DashboardGridComponent } from './dashboard-grid/dashboard-grid.component';
import { DashboardNavComponent } from './dashboard-nav/dashboard-nav.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardsEffects } from './state/dashboard.effects';
import { WidgetwizardComponent } from './widget-wizard/widget-wizard.component';
import { WidgetContainerComponent } from './widget/widget-container/widget-container.component';
import { AreachartComponent } from './widget/widget-types/charts/areachart/areachart.component';
import { BarchartComponent } from './widget/widget-types/charts/barchart/barchart.component';
import { LinechartComponent } from './widget/widget-types/charts/linechart/linechart.component';
import { LabelComponent } from './widget/widget-types/label/label.component';
import { ReportsBarchartComponent } from './widget/widget-types/reports/barchart/reports-barchart.component';
import { ReportsTableComponent } from './widget/widget-types/reports/table/reports-table.component';
import { GetColumnNamePipe } from './widget/widget-types/reports/transform-pipes/get-column-name-pipe';
import { TableComponent } from './widget/widget-types/table/table.component';
import { WebEngageChartComponent } from './widget/widget-types/web-engage/charts/web-engage-chart.component';
import { WebEngageTableComponent } from './widget/widget-types/web-engage/table/web-engage-table.component';
import { SharedSortService } from './widget/widget-utilities/shared-sort.service';
import { AgentswizardComponent } from './widget/widgets/agents/agents-wizard/agents-wizard.component';
import { AgentsComponent } from './widget/widgets/agents/agents/agents.component';
import { CallsWizardComponent } from './widget/widgets/calls/calls-wizard/calls-wizard.component';
import { CallsComponent } from './widget/widgets/calls/calls/calls.component';
import { QueueswizardComponent } from './widget/widgets/queues/queues-wizard/queues-wizard.component';
import { QueuesComponent } from './widget/widgets/queues/queues/queues.component';
import { ReportsDialogHelpComponent } from './widget/widgets/reports/reports-dialog-help/reports-dialog-help.component';
import { ReportsSettingsComponent } from './widget/widgets/reports/reports-settings/reports-settings.component';
import { ReportswizardComponent } from './widget/widgets/reports/reports-wizard/reports-wizard.component';
import { ReportsComponent } from './widget/widgets/reports/reports/reports.component';
import { RuleMatchWizardComponent } from './widget/widgets/web-engage/rule-match-wizard/rule-match-wizard.component';
import { RuleMatchComponent } from './widget/widgets/web-engage/rule-match/rule-match.component';
import { DialogOwnerChange } from '../common/dialogs/dialog-owner-change/dialog-owner-change.component';
import { WidgetUserGroupSelectComponent } from './components/widget-user-group-select/widget-user-group-select.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    declarations: [
        DashboardComponent,
        DashboardNavComponent,
        DashboardGridComponent,
        DialogDashboardNew,
        WidgetContainerComponent,
        WidgetwizardComponent,
        AgentsComponent,
        AgentswizardComponent,
        QueueswizardComponent,
        QueuesComponent,
        CallsWizardComponent,
        CallsComponent,
        ReportswizardComponent,
        ReportsComponent,
        WidgetTypeSelectComponent,
        WidgetSelectComponent,
        WidgetReportSelectComponent,
        WidgetUserGroupSelectComponent,
        WidgetTextboxComponent,
        WidgetNumberboxComponent,
        BarchartComponent,
        LinechartComponent,
        AreachartComponent,
        LabelComponent,
        TableComponent,
        DashboardFilterComponent,
        SortComponent,
        WidgetAgentSelectComponent,
        PreferencesComponent,
        ColorPickerComponent,
        ReportsDialogHelpComponent,
        DialogDatetimepickerComponent,
        RelativeDateSelectComponent,
        ReportsTableComponent,
        ReportsBarchartComponent,
        WidgetReportColumnsSelectComponent,
        GetColumnNamePipe,
        ReportsSettingsComponent,
        DialogCategoriesComponent,
        DashboardAccessIconComponent,
        RuleMatchWizardComponent,
        RuleMatchComponent,
        WebEngageTableComponent,
        WebEngageChartComponent,
        ReportsDatePickerComponent,
        ManualRowSortComponent,
        DialogOwnerChange
    ],
    imports: [
        CommonModule,
        StoreModule.forFeature('dashboard', dashboardReducer),
        EffectsModule.forFeature([DashboardsEffects]),
        I18NextModule.forRoot(),
        NgSelectModule,
        RouterModule,
        GridsterModule,
        ChartModule,
        MatButtonModule,
        MatMenuModule,
        MatInputModule,
        MatTooltipModule,
        MatTabsModule,
        MatDialogModule,
        MatStepperModule,
        MatTableModule,
        MatSortModule,
        MatToolbarModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatCheckboxModule,
        FormsModule,
        ReactiveFormsModule,
        AngularResizeEventModule,
        DragDropModule,
        MatCardModule,
        ColorSketchModule,
        BrowserAnimationsModule,
        SharedModule,
        ScrollingModule,
        TableVirtualScrollModule,
        MatSlideToggleModule,
        MatRadioModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [
        AgentsComponent,
        AgentswizardComponent,
        QueueswizardComponent,
        QueuesComponent,
        CallsWizardComponent,
        CallsComponent,
        ReportswizardComponent,
        ReportsComponent,
        RuleMatchWizardComponent,
        RuleMatchComponent
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-EN' },
        //   {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        SharedSortService
    ],
    exports: [
        ReportswizardComponent,
        ReportsComponent,
        WidgetTextboxComponent,
        WidgetNumberboxComponent,
        WidgetSelectComponent,
        WidgetAgentSelectComponent,
        WidgetReportColumnsSelectComponent,
        WidgetReportSelectComponent,
        WidgetUserGroupSelectComponent,
        WidgetTypeSelectComponent,
        ReportsComponent,
        RelativeDateSelectComponent,
        RuleMatchWizardComponent,
        RuleMatchComponent,
        ReportsDatePickerComponent,
        WebEngageTableComponent,
        MatRadioModule
    ]
})

export class DashboardModule { }
